import React from 'react';
import {get as _get} from 'lodash';

import DefaultForm from '@appComponents/DefaultForm';
import {refetchQueryByName} from '@utils/apollo';
import {EventWatermarkingContentLabel} from '@modules/events/components/EventWatermarking/EventWatermarkingContentLabel';
import {formatCidrsForStorage} from '@modules/events/utils/eventContentWatermarkingCidrHelper';
import {convertToInt} from '@utils/helpers';

export const mapEventWatermarkingContentDropdownOptions = (eventContents = []) => (
    eventContents.map((eventContent) => ({
        value: eventContent.id,
        text: (
            <span>
                <EventWatermarkingContentLabel eventContent={eventContent}/>
            </span>
        ),
    }))
);

export class EventContentWatermarkingForm extends DefaultForm {

    componentDidMount() {
        super.componentDidMount();
        this.props.MessageBox.removeMessage(this.state.defaultForm_formValidationMessageBoxName);

        const refetchListing = () => {
            refetchQueryByName('GetEventWatermarkingListing');
        };

        this.setCreateSuccessCallback(refetchListing);
        this.setUpdateSuccessCallback(refetchListing);
        this.setDeleteSuccessCallback(refetchListing);
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        this.setEventContentDropdownOptions();
        this.props.formValues.id && this.props.formValues.id !== prevProps.formValues.id && this.setClientsDefaultValue();
    }

    setEventContentDropdownOptions() {
        const eventContents = _get(this.props.GraphQLOptionsData, 'eventContentWatermarking.event_contents');

        if (this.state.eventContentOptionsGenerated || !Array.isArray(eventContents)) {
            return;
        }

        this.setField('event_content', {
            options: mapEventWatermarkingContentDropdownOptions(eventContents),
        });
        this.setState(() => ({eventContentOptionsGenerated: true}));
    }

    setClientsDefaultValue() {
        const clients = _get(this.props, 'GraphQLEntityData.eventContentWatermarking.clients');

        if (this.state.clientsDefaultValueSet || !Array.isArray(clients)) {
            return;
        }

        this.setField('clients', {
            defaultValue: clients.map((client) => client.id),
        });
        this.setState(() => ({clientsDefaultValueSet: true}));
    }

    prepareDataForSubmit(data) {
        return {
            id: data.id,
            event_content: convertToInt(data.event_content),
            cidrs: formatCidrsForStorage(data.cidrs),
            clients: data.clients ?? [],
            description: data.description ?? '',
        };
    }
}

export default EventContentWatermarkingForm;
